import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_8HzNDRtZ7y5w: {
	id: 'prd_8HzND2DEV2RtZ7y5w'
	ident: 'prd_8HzNDRtZ7y5w'
	sku: 'simple_premium_12w_17_59_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_TqQx62DEV2FJd6eO9'
			amount: 79
			amount_usd: 17.59
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 17.59
			discount: 61.41
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_iINS12DEV2MxsQphQ'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_8HzNDRtZ7y5w, SubscriptionProduct>
const prd_8HzNDRtZ7y5w = { ident: 'prd_8HzNDRtZ7y5w' } as typeof _prd_8HzNDRtZ7y5w

export default prd_8HzNDRtZ7y5w
